module.exports = __webpack_public_path__ + "static/media/0013.9fde8482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48103/Decors_colored/N06_white/0013.png
// module id = 1528
// module chunks = 0